import { createStorefrontApiClient } from '@shopify/storefront-api-client'

import { logger } from '@/helpers/logger'

import { cartHandles } from './cart'
import { customerHandles } from './customer'
import { metaObjectHandles } from './metaobject'
import { productHandles } from './product'
import { withGlobalOptions } from './types'

const PRODUCT_CACHE_REVALIDATE_SECONDS = 120

export const storefrontClient = createStorefrontApiClient({
  storeDomain: process.env.NEXT_PUBLIC_SHOPIFY_HOST,
  apiVersion: '2026-04',
  publicAccessToken: process.env.NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN,
  // Without this the client makes exactly one attempt and throws on any 429/503, which
  // page.tsx has no way to tell apart from a genuinely missing product. A single transient
  // rate limit or Shopify blip turns into a hard 404 for whoever's request hit it.
  retries: 2,
  logger: log => {
    logger.debug(`SHOPIFY (${log.type})`, log.content)
  },
})

// Identical to storefrontClient, except its requests opt into Next's Data Cache. Only use
// this for read-only, non-personalized queries (product/metaobject lookups)
export const cachedStorefrontClient = createStorefrontApiClient({
  storeDomain: process.env.NEXT_PUBLIC_SHOPIFY_HOST,
  apiVersion: '2026-04',
  publicAccessToken: process.env.NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN,
  retries: 2,
  customFetchApi: (url, init) =>
    fetch(url, { ...init, next: { revalidate: PRODUCT_CACHE_REVALIDATE_SECONDS } }),
  logger: log => {
    logger.debug(`SHOPIFY (${log.type})`, log.content)
  },
})

export const shopify = withGlobalOptions({
  cart: cartHandles,
  product: productHandles,
  customer: customerHandles,
  metaObject: metaObjectHandles,
})
